import { useRef, useState } from "react";
import { toast } from "sonner";
import { transcribe } from "@/lib/api";

export const useRecorder = (onText) => {
  const [state, setState] = useState("idle");
  const rec = useRef(null);

  const start = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const chunks = [];
      const mr = new MediaRecorder(stream);
      mr.ondataavailable = (e) => chunks.push(e.data);
      mr.onstop = async () => {
        stream.getTracks().forEach((t) => t.stop());
        setState("busy");
        try {
          const text = await transcribe(new Blob(chunks, { type: "audio/webm" }));
          if (text) onText(text);
          else toast("I didn't catch that. Try again?");
        } catch {
          toast.error("Couldn't understand the recording");
        }
        setState("idle");
      };
      mr.start();
      rec.current = mr;
      setState("recording");
    } catch {
      toast.error("Microphone not available. You can type instead!");
    }
  };

  const stop = () => rec.current?.stop();
  const toggle = () => (state === "recording" ? stop() : state === "idle" && start());

  return { state, toggle };
};
